<template>
    <main>
        <div class="preloader" v-if="stop">
            <img src="../assets/img/bouncing-squares.svg" alt="Pre-loader" width="100">
        </div>

        <div class="carousel-container">
            <div class="carousel-slide" v-for="(slide, i) in slides" :key="i" :class="{ active: currentIndex === i }">
                <img :src="slide.img" alt="" class="slide-image" />
                <div class="overlay"></div>
                <div class="carousel-content text-center">
                    <h2>{{ slide.title }}</h2>
                    <h4>{{ slide.description }}</h4>
                    
                </div>
            </div>
            <button class="nav left" @click="prevSlide">←</button>
            <button class="nav right" @click="nextSlide">→</button>
            <div class="dots">
                <span v-for="(slide, i) in slides" :key="i" :class="{ active: currentIndex === i }"
                    @click="currentIndex = i"></span>
            </div>
        </div>

        <div class="py-5"
            style="background: linear-gradient(225deg, rgba(0, 100, 208, 0.05) 0%, rgba(80, 152, 236, 0.05) 100%);">
            <div class="container py-5">
                <div class="col-lg-10 mx-auto">
                    <div class="col-sm-10 col-lg-8 mx-auto text-center mb-5">
                        <h1 class="style_bold">Découvrez plus à travers <span class="text-primary">nos actualités</span>
                        </h1>
                    </div>

                    <div class="row mb-4">
                        <div class="col-lg-6 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100" v-if="filterItems.length > 0">
                                <div>
                                    <div class="style_bg_img mb-3 rounded-2"
                                        :style="{ backgroundImage: `url(${getImageUrl(filterItems[0].image.id)})`, height: '230px' }">
                                    </div>
                                    <h5><a href="#">{{ filterItems[0].title }}</a></h5>
                                    <p class="mb-0">{{ truncateAddress(filterItems[0].details, 300) }}
                                        <router-link
                                            :to="{ name: 'detail-actualite', params: { id: filterItems[0]?.id } }"
                                            class="style_link text-primary">
                                            Lire Plus
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div v-for="(actualite, index) in filterItems.slice(1, 4)" :key="index"
                                class="p-3 rounded-4 bg-white mb-3">
                                <div class="d-flex gap-3">
                                    <div>
                                        <div class="style_bg_img mb-3 rounded-2"
                                            :style="{ backgroundImage: `url(${getImageUrl(actualite.image.id)})`, height: '100px', width: '100px' }">
                                        </div>
                                    </div>
                                    <div>
                                        <h5><router-link :to="{ name: 'detail-actualite' }">{{ actualite.title
                                                }}</router-link></h5>
                                        <p class="mb-0">{{ truncateAddress(actualite.details, 50) }}
                                            <router-link
                                                :to="{ name: 'detail-actualite', params: { id: actualite?.id } }"
                                                class="style_link text-primary">
                                                Lire Plus
                                            </router-link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mx-auto text-center">
                        <router-link to="/actualite-list" class="btn btn-primary text-nowrap style_gradient"
                            type="button">Voir toutes les
                            actualités</router-link>
                    </div>
                </div>
            </div>

        </div>

        <div class="container my-5">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="mb-0 font-weight-bold">Nos Formations</h2>
                <div class="d-flex gap-2">
                    <div class="swiper-navigation-buttons">
                        <div class="custom-prev">
                            <i class="bi bi-chevron-left"></i>
                        </div>
                        <div class="custom-next">
                            <i class="bi bi-chevron-right"></i>
                        </div>
                    </div>

                </div>
            </div>

            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="event in formationsActives" :key="event.id">
                        <div v-if="event.id !== 'voir-plus'" class="card h-100 shadow-sm">
                            <!-- Ta carte normale d'événement -->
                            <img :src="getImageUrl(event.image.id)" class="card-img-top" alt="Event Image"
                                style="height: 200px; object-fit: cover;">
                            <div class="card-body d-flex flex-column">
                                
                                <h5 class="card-title">{{ truncate(event.title, 30) }}</h5>
                                <p class="text-muted mb-1">
                                    <i class="bi bi-calendar-alt"></i> {{ formatDate(event.dateDebutFormation) }} |
                                    <i class="fas fa-map-marker-alt"></i> {{ truncate(event.lieu, 25) }}
                                </p>
                                <p class="card-text flex-grow-1">{{ truncate(event.details, 100) }}</p>
                                <router-link :to="{ name: 'detail-formation', params: { id: event?.code } }" class="mt-auto btn btn-link p-0 text-primary">
                                    Lire la suite <i class="bi bi-arrow-right"></i>
                                </router-link>
                                
                            </div>
                        </div> 

                        <!-- Sinon on affiche la carte spéciale "Voir plus" -->
                        <div v-else class="swiper-slide d-flex">
                            <div
                                class="card h-100 d-flex flex-column justify-content-center align-items-center p-4 custom-card">
                                <div class="text-center">
                                    <h1 class="card-title style_bold">Consulter toutes les formations</h1>
                                    <router-link to="/formation-list" class="btn btn-primary btn-actualites">
                                        Voir toutes les formations
                                        <i class="bi bi-arrow-right ms-2"></i>
                                    </router-link>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </div>



        <div class=""
            style="background: linear-gradient(225deg, rgba(0, 100, 208, 0.05) 0%, rgba(80, 152, 236, 0.05) 100%);">
            <div class="container py-5">
                <div class="row align-items-center">
                    <div class="col-6 col-sm-3 col-lg-2">
                        <h5>Découvrez nos Partenaires :</h5>
                    </div>
                    <div class="col-6 col-sm-9 col-lg-10">
                        <div class="" id="slide_patenaire">
                            <div class="px-2">
                                <a href="https://fidef.org/" target="_blank"
                                    class="d-block py-3 px-3 px-sm-5 rounded-3">
                                    <img src="@/assets/img/Partenaires/FIDEF-LOGO.png" class="img-fluid w-100">
                                </a>
                            </div>
                            <div class="px-2">
                                <a href="https://www.ifac.org/" target="_blank"
                                    class="d-block py-3 px-3 px-sm-5 rounded-3">
                                    <img src="@/assets/img/Partenaires/IFAC-mobile.png" class="img-fluid w-100">
                                </a>
                            </div>
                            <div class="px-2">
                                <a href="https://abwa.org.ng/" target="_blank"
                                    class="d-block py-3 px-3 px-sm-5 rounded-3">
                                    <img src="@/assets/img/Partenaires/logoabwa.png" class="img-fluid w-100">
                                </a>
                            </div>
                            <div class="px-2">
                                <a href="https://www.pafa.org.za/" target="_blank"
                                    class="d-block py-3 px-3 px-sm-5 rounded-3">
                                    <img src="@/assets/img/Partenaires/pafa.org.za.png" class="img-fluid w-100">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='bg-dark py-5'>
                <div class="container">
                    <div class="row g-4">
                        <!-- Ville couvertes -->
                        <div class="col-md-6 col-lg-4">
                            <div
                                class="p-4 rounded-4 d-flex flex-column justify-content-center text-center h-100 stat-card">
                                <h1 class="display-3 text-white mb-2">
                                    <ICountUp :delay="delay" :endVal="225" :options="options" />
                                </h1>
                                <h5 class="text-white-50 mb-3">Experts-Comptables</h5>
                                
                            </div>
                        </div>

                        <!-- Emplois -->
                        <div class="col-md-6 col-lg-4">
                            <div
                                class="p-4 rounded-4 d-flex flex-column justify-content-center text-center h-100 stat-card">
                                <h1 class="display-3 text-white mb-2">
                                    <ICountUp :delay="delay" :endVal="138" :options="options" />
                                </h1>
                                <h5 class="text-white-50 mb-3">Sociétés d’expertise comptable</h5>
                                
                            </div>
                        </div>

                        <!-- Budget -->
                        <div class="col-md-6 col-lg-4">
                            <div
                                class="p-4 rounded-4 d-flex flex-column justify-content-center text-center h-100 stat-card">
                                <h1 class="display-3 text-white mb-2">
                                    <ICountUp :delay="delay" :endVal="3" :options="options" />
                                </h1>
                                <h5 class="text-white-50 mb-3">Centres de gestion agréés</h5>
                                
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>

        </div>

        <div class="py-5"
            style="background: linear-gradient(225deg, rgba(0, 100, 208, 0.05) 0%, rgba(80, 152, 236, 0.05) 100%);">
            <div class="container py-5">
                <div class="col-lg-10 mx-auto">
                    <div class="col-sm-10 col-lg-8 mx-auto text-center mb-5">
                        <h1 class="style_bold">Vous pouvez <span class="text-primary">solliciter</span></h1>
                        <!-- <p>L’Ordre est une institution nationale dotée de la personnalité morale et regroupant tous les professionnels habilités à exercer les professions d’Experts-Comptables et de Comptables Agréés au Bénin.</p> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-4 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100">
                                <div class="d-flex justify-content-center align-items-center text-primary bg-primary bg-opacity-10 rounded-3 mb-3"
                                    style="width: 50px; height: 50px;">
                                    <i class="bi-shield-fill-exclamation"></i>
                                </div>
                                <h4>Audit Légal</h4>
                                <p class="mb-0">Commissariat aux apports; Commissariat à la transformation; Commissariat
                                    aux comptes</p>
                            </div>
                        </div>
                        <div class="col-sm-4 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100">
                                <div class="d-flex justify-content-center align-items-center text-primary bg-primary bg-opacity-10 rounded-3 mb-3"
                                    style="width: 50px; height: 50px;">
                                    <i class="bi-people-fill"></i>
                                </div>
                                <h4>Représentation</h4>
                                <p class="mb-0">Surveillance de comptabilité; Organisation comptable; Établissement de
                                    périodiques</p>
                            </div>
                        </div>
                        <div class="col-sm-4 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100">
                                <div class="d-flex justify-content-center align-items-center text-primary bg-primary bg-opacity-10 rounded-3 mb-3"
                                    style="width: 50px; height: 50px;">
                                    <i class="bi-bar-chart-fill"></i>
                                </div>
                                <h4>Conseil et Gestion</h4>
                                <p class="mb-0">Conseil juridique et fiscal; Gestion d’entreprise; gestion du patrimoine
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100">
                                <div class="d-flex align-items-center gap-2">
                                    <div>
                                        <h4>Audit Contractuel</h4>
                                        <p class="mb-0">Audit comptable et financier; Audit organisationnel et
                                            institutionnel; Audit des ressources humaines</p>
                                    </div>
                                    <h1 class="mb-0 display-4 text-primary"><i class="bi-signpost-fill"></i></h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div class="p-3 rounded-4 bg-white h-100">
                                <div class="d-flex align-items-center gap-2">
                                    <div>
                                        <h4>Assistance Juridique</h4>
                                        <p class="mb-0">Expertise judiciaire; Administration judiciaire; Liquidation de
                                            société.</p>
                                    </div>
                                    <h1 class="mb-0 display-4 text-primary"><i class="bi-hammer"></i></h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VUE_APP_API_URL } from '@/config/config';
import moment from "moment";
import ICountUp from "vue-countup-v2";
import SwiperCore, { Navigation, Pagination } from 'swiper/core';

SwiperCore.use([Navigation, Pagination]);

export default {
    components: {
        ICountUp,
    },
    data() {
        return {
            suivi: {
                codeRef: '',
                email: '',
            }, suivis: [], page: 0, delay: 5000,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: "",
                decimal: ".",
                prefix: "",
                suffix: "",
            }, formationsActives: [], stop: false,
            slides: [
                {
                    img: require('@/assets/img/baniere/5.jpeg'),
                    title: "Bienvenue sur le portail de",
                    description: "L'Ordre des Experts Comptables et Comptables Agréés du Bénin",
                    link: "#"
                },
                {
                    img: require('@/assets/img/baniere/3.jpeg'),
                    title: "Bienvenue sur le portail de",
                    description: "L'Ordre des Experts Comptables et Comptables Agréés du Bénin",
                    link: "#"
                },
                {
                    img: require('@/assets/img/baniere/4.jpeg'),
                    title: "Bienvenue sur le portail de",
                    description: "L'Ordre des Experts Comptables et Comptables Agréés du Bénin",
                    link: "#"
                }
            ], currentIndex: 0,
            events: [
                {
                    id: 1,
                    image: require('@/assets/img/actualites/1.jpg'),
                    category: 'Séminaires et Formation',
                    status: 'En cours',
                    title: 'Campagne de salubrité à Parakou',
                    date: '08 Mars 2025',
                    location: 'Parakou',
                    description: 'Dans le cadre de la lutte contre l’insalubrité, une campagne a été organisée avec les élus locaux...'
                },
                {
                    id: 2,
                    image: require('@/assets/img/actualites/2.jpg'),
                    category: 'Sensibilisation',
                    status: 'En cours',
                    title: 'Campagne de recyclage',
                    date: '03 Avril 2025',
                    location: 'Cotonou',
                    description: 'Sensibilisation des populations sur le tri sélectif et le recyclage des déchets...'
                },
                {
                    id: 3,
                    image: require('@/assets/img/actualites/3.jpg'),
                    category: 'Séminaires et Formation',
                    status: 'À venir',
                    title: 'Séminaire sur la fiscalité',
                    date: '15 Mai 2025',
                    location: 'Cotonou',
                    description: 'Un séminaire sur la fiscalité internationale sera organisé pour les experts comptables...'
                },
                {
                    id: "voir-plus",
                }


            ]
        };
    },
    computed: {
        ...mapGetters({ items: 'actualite/all' }),
        filterItems() {
            const today = new Date().toISOString().split('T')[0];
            // Vérifier que this.items.data est bien un tableau sinon on retourne un tableau vide
            const list = Array.isArray(this.items.data?.content) ? this.items.data?.content : [];

            return list
                .filter(item => item.published && item.dateDeb <= today && item.dateFin >= today)
                .slice(0, 4);
        }
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format('LL') : '';
        },
        truncateAddress(address, length) {
            if (!address) {
                return '';
            }
            if (address.length <= length) {
                return address;
            }
            return address.slice(0, length) + '...';
        },
        truncate(text, length) {
            if (text.length <= length) return text;
            return text.substr(0, length) + '...';
        },
        onSearch(offset) {
            this.stop = true;
            if (offset > 0) this.page = offset;
            this.$router.push({ query: this.page }).catch(() => { });
            this.$store.dispatch('actualite/getAllP', this.page)
                .then((response) => {
                    //console.log('Réponse API complète :', response);
                })
                .finally(() => this.stop = false);
        },
        getImageUrl(idfile) {
            return `${VUE_APP_API_URL}fichier/download/${idfile}`;
        },
        async listFormation() {
            try {
                const response = await this.$store.dispatch('formation/getAllP');
                this.formationsActives = response.data.content.slice(0, 3);
                this.formationsActives.push({
                    id: "voir-plus",
                });
                                
            } catch (error) {
                console.error('Erreur lors de la récupération des formations :', error);
            }
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        },
        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        }

    },
    created() {
        this.onSearch();
        this.listFormation();
    },
    mounted() {
        this.$nextTick(() => {
            $('#slide_patenaire').slick({
                speed: 5000,
                autoplaySpeed: 0,
                autoplay: true,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                useTransform: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],
                prevArrow: false,
                nextArrow: false
            });
        });

        this.$nextTick(() => {
            new Swiper('.swiper-container', {
                slidesPerView: 3,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.custom-next',
                    prevEl: '.custom-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    }


};
</script>

<style scoped>
.row {
    position: relative;
}

.preloader {
    background-color: #ffffff;
    position: fixed;
    z-index: 999999;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.preloader img {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}


.carousel-container {
    position: relative;
    width: 100%;
    height: 620px;
    overflow: hidden;
    border-radius: 10px;
}

.carousel-slide {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s ease-in-out;
}

.carousel-slide.active {
    opacity: 1;
}

/* Style pour l'image */
.slide-image {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Permet de remplir le conteneur */
    /* Pour afficher le haut de l'image : */
    object-position: top center;
    z-index: 0;
}

/* Overlay pour l'ombre */
.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
    z-index: 1;
}

.carousel-content {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 6%;
    transform: translateY(-50%);
    color: white;
    max-width: 90%;
    width: 90%;
}

.carousel-content h2 {
    font-size: 3rem;
    white-space: normal;
    word-break: break-word;
    font-weight: bold;
}

.carousel-content p {
    margin-top: 1rem;
    font-size: 1.1rem;
}

.carousel-content .btn {
    display: inline-block;
    margin-top: 1rem;
    background: #2b87e3;
    padding: 0.75rem 1.5rem;
    color: white;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
}

.nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.3);
    color: white;
    font-size: 1.5rem;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    z-index: 2;
}

.nav.left {
    left: 10px;
}

.nav.right {
    right: 10px;
}

.dots {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
}

.dots span {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 4px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    cursor: pointer;
}

.dots span.active {
    background: #2b87e3;
}

.swiper-container {
    width: 100%;
    overflow: hidden;
}

.swiper-wrapper {
    display: flex;
}

.swiper-slide {
    width: auto;
    flex-shrink: 0;
}

.swiper-navigation-buttons {
    display: flex;
    gap: 10px;
}

.custom-prev,
.custom-next {
    width: 40px;
    height: 40px;
    background-color: #2b87e3;
    /* vert vif */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    /* ombre légère */
    transition: background-color 0.3s ease;
}

.custom-prev i,
.custom-next i {
    color: white;
    font-size: 24px;
}

.custom-prev:hover,
.custom-next:hover {
    background-color: #2b87e3;
    /* légèrement plus foncé au hover */
}

.bg-dark {
    background-color: rgb(32, 30, 30) !important;
    background: url("../assets/img/04.png") no-repeat center center;
    background-size: cover;
}

.custom-card {
    background: url("../assets/img/header-bg.png") no-repeat center center;
    padding-top: 7rem !important;
    /* Gros padding en haut */
    padding-bottom: 9rem !important;
    /* Gros padding en bas */
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}


.btn-actualites {
    background-color: #2b87e3;
    border: none;
    padding: 0.5rem 1.5rem;
    font-weight: 500;
}

.btn-actualites:hover {
    background-color: #2070bf;
}

.stat-card {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    
    .stat-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.15);
    }
    
    .display-3 {
        font-weight: 700;
        background: linear-gradient(to right, #4facfe, #00f2fe);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
</style>